
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/categories",
      function () {
        return require("private-next-pages/brands/categories/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/categories"])
      });
    }
  